package link.erpango.quip.data.db.entities

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import link.erpango.quip.QuipConstants
import link.erpango.quip.db.QuipDb
import link.erpango.quip.domain.entities.DAuth
import kotlin.coroutines.CoroutineContext
import app.cash.sqldelight.async.coroutines.awaitAsOneOrNull

class AuthDAO(
    private val db: QuipDb
): IAuthTable {
    override suspend fun insertToken(
        userId: String,
        accessToken: String,
        refreshToken: String,
        createdAt: Long
    ) {
        db.authQueries.insert(
            user_id = userId,
            session_token = accessToken,
            refresh_token = refreshToken,
            created_at = createdAt
        )
    }

    override fun observeAuth(coroutineContext: CoroutineContext): Flow<DAuth?> {
        return db.authQueries.selectAll().asFlow().mapToList(coroutineContext).map { it.firstOrNull()?.toDAuth() }
    }

    override suspend fun selectCurrentLoggedUserId(): String? {
        return db.authQueries.selectLastUserId().awaitAsOneOrNull()?.user_id
    }

    override suspend fun selectAccessToken(userId: String): String? {
        return db.authQueries.select(userId).awaitAsOneOrNull()?.session_token
    }

    override suspend fun selectRefreshToken(userId: String): String? {
        return db.authQueries.select(userId).awaitAsOneOrNull()?.refresh_token
    }

    override suspend fun deleteToken(userId: String) {
        db.authQueries.delete(userId)
    }

    override suspend fun select(userId: String): DAuth? {
        return db.authQueries.select(userId).awaitAsOneOrNull()?.toDAuth()
    }

    override suspend fun updateToken(
        userId: String,
        accessToken: String,
        refreshToken: String,
        createdAt: Long
    ) {
        db.authQueries.update(
            session_token = accessToken,
            refresh_token = refreshToken,
            created_at = createdAt,
            user_id = userId
        )
    }

    override suspend fun deleteAllTokens() {
        db.authQueries.deleteAll()
    }

    /**
     * Obtiene la primera autenticación guardada en la base de datos.
     * @return DAuth? objeto de autenticación o null si no hay ninguna
     */
    override suspend fun getFirstAuth(): DAuth? {
        return db.authQueries.selectAll().awaitAsOneOrNull()?.toDAuth()
    }

    override suspend fun getAppVersionCode(): String? {
        return db.commonValuesQueries.selectValue(QuipConstants.CommonValues.SystemInfo.appVersionCode).awaitAsOneOrNull()
    }
}

fun linkerpangoquipdb.Auth_table.toDAuth(): DAuth {
    return DAuth(
        user = user_id,
        access = session_token,
        refresh = refresh_token,
        expiresIn = null,
        createdAt = created_at
    )
}